export default {
  content: '',
  faqHeader: 'bg-[#05375A] pb-16 pt-[120px] sm:pt-[150px]',
  heading: 'font-interBold text-[48px] text-color-white mb-[48px] text-center',
  inputWrapper: 'max-w-[740px] mx-auto mb-[48px] w-[100%] mx-auto flex flex-col justify-center sm:flex-row gap-1 sm:gap-[0] px-10 md:px-5 lg:px-0',
  input: 'w-[100%] sm:w-[45%] h-[50px] pl-[20px] pr-[5px] font-inter rounded-l-lg rounded-r-lg sm:rounded-r-none',
  button: 'h-[50px] px-4 bg-[#EC6D25] text-color-white font-interMedium rounded-r-lg rounded-l-lg sm:rounded-l-none cursor-pointer hover:brightness-105 transition duration-300',
  topicList: 'flex flex-wrap justify-center max-w-[740px] mx-auto px-10 sm:px-5 md:px-0 gap-2',
  bgContentWrapper: 'flex flex-col items-center gap-[40px] lg:flex-row lg:justify-around lg:items-start lg:gap-[20px] px-2 md:px-0 sm:pt-0 sm:mt-0 pt-28 -mt-28',
  bgContent: 'pt-16 pb-20 max-w-[740px]',
};
